<template>
  <PinBtn
    v-if="!hide_pin_controls"
    :item="item"
    :myKey="myKey"></PinBtn>
  <PinAutoRefreshBtn
    v-if="!currentTemplate && !hide_activate_controls"
    :item="item"
    :myKey="myKey" />
  <v-card
    v-if="deluge?.pinned_svars"
    :style="`opacity: ${opaqueMode ? 1 : 0.5}`"
    flat
    class="mb-2"
    style="width: 100%; background: var(--v-field-color)">
    <v-card-subtitle class="pb-0 pt-2">{{ item.label }}</v-card-subtitle>
    <div class="px-2">
      <v-switch
        v-model="item.value"
        class="py-0 px-2"
        hide-details
        color="primary"
        :disabled="readOnlyMode"
        inset></v-switch>
    </div>
  </v-card>
  <v-spacer />
  <v-icon
    v-if="currentTemplate?.src_scene_data?.[myKey]"
    variant="flat"
    class="ml-3 refresh-button"
    style="height: 56px !important"
    @click="handleUserIntent(myKey, originLevel)"
    :style="unLockedMode ? 'opacity: 0.3' : 'opacity: 0.7'"
    :title="
      unLockedMode
        ? 'Value inherits from Template or Source'
        : 'Value locked. (Will not inherit from Template or Source)'
    "
    :icon="
      unLockedMode ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline'
    "></v-icon>

  <!-- <PinSendNowBtn
    v-if="!currentTemplate"
    :item="item"
    :myKey="myKey" /> -->
</template>
<script setup>
import { watch, ref } from 'vue';
import { deluge } from '@/stores/deluge.js';

import PinBtn from './PinBtn.vue';
import PinAutoRefreshBtn from './PinAutoRefreshBtn.vue';
import PinSendNowBtn from './PinSendNowBtn.vue';
import { isOpaque } from './utils.js';
import { computed, defineProps } from 'vue';
const opaqueMode = computed(() => {
  return isOpaque(deluge, props);
});
import { inheritanceHandler } from '../../../utils/inheritanceHandler';
const props = defineProps([
  'currentTemplate',
  'resetFunc',
  'originLevel',
  'item',
  'myKey',
  'hideicons',
  'hide_pin_controls',
  'hide_activate_controls',
  'readOnlyMode',
]);

const emit = defineEmits(['valueChanged']);

watch(
  () => props.item.value,
  () => {
    emit('valueChanged', [props.myKey, props.item.value]);
  }
);

const unLockedMode = ref(props.item.keyInherited);

function handleUserIntent(myKey, originLevel) {
  if (props.readOnlyMode) return;
  unLockedMode.value = !unLockedMode.value;
  props.item.userIntent = unLockedMode.value === true ? 'remove' : 'keep';
  if (unLockedMode.value === true) {
    props.resetFunc(myKey, originLevel);
  }
}

watch(
  () => props.item.value,
  () => {
    inheritanceHandler(props.item);
  },
  // It's required to run this watcher immediately
  // else the value will change before the handler tracks the initial value
  { immediate: true }
);
</script>
<style scoped></style>
